import { atom } from "recoil";
import { TraceDataConfig } from "../Types/Trace";

export const visibleTracesAtom = atom<TraceDataConfig[]>({
    key: "visibleTraces",
    default: []
})